module.exports = __webpack_public_path__ + "static/kontact-link-bg-8992158ce0db368dc7e5e062b239349e.jpg";